export default "__VITE_ASSET__D1mcGFea__"